var CurrencyMixin = {
  filters: {
    toCurrency: function (value, locale, currency) {

      let localeFinal = (locale != null && locale != undefined) ? locale : 'es-ES';
      let currencyFinal = (currency != null && currency != undefined) ? currency : 'EUR';
      var formatted = new Intl.NumberFormat(localeFinal, {
        style: 'currency',
        currency: currencyFinal
      }).format(Number(value));

      /* La API Intl de Javascript para las configuraciones de localización utiliza la información establecida por el 
      Unicode Common Locale Data Repository (CLDR)
      Actualmente el CLDR ha establecido para el sistema numérico en español que los "dígitos mínimos para agrupar" es igual a 2. */
      //HACK
      if (locale.substr(0, 2) == 'es' && value >= 1000 && value < 10000) {
        const number = 10000;
        let sep = number.toLocaleString(locale).substring(2, 3);
        if (!formatted.includes(sep)) {
          let pre = formatted.substr(0, 4);
          formatted = formatted.replace(pre, pre.slice(0, 1) + sep + pre.slice(1, 4));
        }
      }

      return formatted;


    }
  }
};
export default CurrencyMixin;